import CompanyLogo from './CompanyLogo'

export default CompanyLogo
